import './ConfirmCard.css';

interface ConfirmCardProps {
  /** The confirmation question to show (e.g. "Delete 'x.md'? …"). */
  prompt: string;
  /** Resolution outcome once the user has answered, or undefined while pending. */
  resolved?: 'confirmed' | 'dismissed';
  /** User approved — re-ask the agent to perform the delete. */
  onConfirm: () => void;
  /** User declined — dismiss without acting. */
  onDismiss: () => void;
}

/**
 * An in-chat Yes/No confirmation for a destructive action (currently a file
 * delete). Surfaced when a `doc_delete` call returns `confirmation_required`:
 * the agent never deletes without the user clicking "Yes" here, which sends a
 * confirming turn so the agent re-issues the delete with the user's approval.
 */
export default function ConfirmCard({
  prompt,
  resolved,
  onConfirm,
  onDismiss,
}: ConfirmCardProps) {
  return (
    <div className="om-confirm" role="group" aria-label="Confirm deletion">
      <span className="om-confirm__icon" aria-hidden="true">
        ⚠
      </span>
      <div className="om-confirm__body">
        <p className="om-confirm__prompt">{prompt}</p>
        {resolved === undefined ? (
          <div className="om-confirm__actions">
            <button
              type="button"
              className="om-confirm__btn om-confirm__btn--danger"
              onClick={onConfirm}
            >
              Yes, delete
            </button>
            <button type="button" className="om-confirm__btn" onClick={onDismiss}>
              No, keep it
            </button>
          </div>
        ) : (
          <div className="om-confirm__resolved">
            {resolved === 'confirmed' ? 'Deletion confirmed.' : 'Cancelled — nothing was deleted.'}
          </div>
        )}
      </div>
    </div>
  );
}
